import React from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useParams } from 'react-router';
import QueryRenderer from '../../../../../shared/relay/QueryRenderer';
import {
  withTableHistoryProvider,
  useTableHistoryQueryVariables
} from '../../../../../shared/contexts/tableHistoryContext';
import { PAGINATION_TYPES } from '../../../../../shared/constants';
import SolicitationReferencesList from './SolicitationReferencesList';

const SolicitationReferenceTab = () => {
  const variables = useTableHistoryQueryVariables();
  const { id } = useParams();

  return (
    <QueryRenderer
      query={graphql`
        query SolicitationReferenceTabQuery($id: ID!, $first: Int, $after: String) {
          solicitation(id: $id) {
            ...SolicitationReferencesList_solicitation
          }
        }
      `}
      variables={{ id, ...variables }}
      render={relayProps => <SolicitationReferencesList solicitation={relayProps.solicitation} />}
    />
  );
};

export default withTableHistoryProvider(SolicitationReferenceTab, 'orgSolicitationReferences', {
  rowsPerPage: PAGINATION_TYPES.short.defaultValue
});
